import { useEffect, useState } from 'react';

import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

interface LogoPrimaryShapeProps extends BaseSVGType {
  animated?: boolean;
}

const LogoPrimaryShape = ({
  width = 150,
  height = 50,
  fillColor = '#fff',
  style,
  animated = true
}: LogoPrimaryShapeProps) => {
  const [isVisible, setIsVisible] = useState(!animated);

  useEffect(() => {
    if (!animated) {
      setIsVisible(true);
      return;
    }

    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, [animated]);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1000 1000"
      xmlns="http://www.w3.org/2000/svg"
      fill={fillColor}
      style={{
        ...style,
        opacity: isVisible ? 1 : 0,
        transition: animated ? 'opacity 1.2s ease-out' : 'none'
      }}
    >
      <g>
        <path
          className="cls-2"
          d="M317.94,292.23v-88.19h14.99v45.86l40.69-45.86h18.52l-36.41,40.57,37.54,47.62h-18.52l-28.85-36.54-12.98,14.36v22.17h-14.99Z"
        />
        <path
          className="cls-2"
          d="M386.1,225.46h15.5l19.78,49.39,18.9-49.39h15.5l-37.42,93.23h-15.12l10.71-26.84-27.84-66.4Z"
        />
        <path
          className="cls-2"
          d="M466.61,202.15c1.85-1.76,4.07-2.65,6.68-2.65s4.81.86,6.61,2.58c1.8,1.72,2.71,3.89,2.71,6.49s-.88,4.75-2.65,6.43c-1.85,1.76-4.07,2.65-6.68,2.65s-4.83-.86-6.68-2.58c-1.85-1.72-2.77-3.88-2.77-6.49s.92-4.66,2.77-6.43ZM480.34,225.46v66.77h-14.49v-66.77h14.49Z"
        />
        <path
          className="cls-2"
          d="M491.05,225.46h15.5l18.39,58.46,18.39-58.46h15.5l-21.92,66.77h-23.81l-22.05-66.77Z"
        />
      </g>

      <g>
        <path
          className="cls-1"
          d="M572.93,292.36v-88.44h31.37c12.6,0,23.27,4.24,32,12.72,8.74,8.49,13.1,18.98,13.1,31.5v.38c0,12.35-4.33,22.74-12.98,31.18-8.65,8.44-19.36,12.66-32.13,12.66h-31.37ZM587.92,278.37h16.38c8.99,0,16.29-2.88,21.92-8.63,5.63-5.75,8.44-12.96,8.44-21.61s-2.83-16.06-8.5-21.73c-5.67-5.67-12.96-8.5-21.86-8.5h-16.38v60.47Z"
        />
        <path
          className="cls-1"
          d="M668.05,234.4c6.47-6.72,14.32-10.08,23.56-10.08s16.13,3.36,21.42,10.08v-8.95h14.49v66.77h-14.49v-8.95c-5.29,6.64-12.43,9.95-21.42,9.95s-16.99-3.38-23.5-10.14c-6.51-6.76-9.76-14.85-9.76-24.25s3.23-17.72,9.7-24.44ZM671.83,258.84c0,5.88,2.04,10.9,6.11,15.05,4.07,4.16,9.05,6.24,14.93,6.24s10.77-2.1,14.93-6.3c4.16-4.2,6.24-9.2,6.24-14.99s-2.08-10.81-6.24-15.06c-4.16-4.24-9.13-6.36-14.93-6.36s-10.86,2.1-14.93,6.3c-4.08,4.2-6.11,9.24-6.11,15.12Z"
        />
        <path
          className="cls-1"
          d="M738.35,238.05v-12.6h12.6v-16l14.24-4.16v20.16h20.54v12.6h-20.54v32.51c0,4.12,1.2,6.68,3.59,7.68s4.56,1.51,6.49,1.51c3.02,0,6.68-.67,10.96-2.02v13.98c-4.54,1.26-8.69,1.89-12.47,1.89-4.96,0-10-1.45-15.12-4.35-5.13-2.9-7.69-9.09-7.69-18.58v-32.63h-12.6Z"
        />
        <path
          className="cls-1"
          d="M802.98,234.4c6.72-6.72,14.78-10.08,24.19-10.08,8.4,0,15.73,2.71,21.99,8.13,6.26,5.42,10.1,12.2,11.53,20.35.5,2.02.76,4.03.76,6.05,0,1.76-.21,3.53-.63,5.29h-53.67c.84,4.96,3.13,8.9,6.87,11.84,3.74,2.94,8.13,4.41,13.17,4.41,7.73,0,13.9-2.77,18.52-8.32l12.85,3.4c-2.69,5.38-6.99,9.68-12.91,12.91-5.92,3.24-12.07,4.85-18.46,4.85-9.66,0-17.79-3.36-24.38-10.08-6.59-6.72-9.89-14.82-9.89-24.31s3.36-17.72,10.08-24.44ZM807.14,253.05h39.56c-.84-4.45-3.05-8.21-6.61-11.28-3.57-3.06-7.92-4.6-13.04-4.6s-9.49,1.53-13.1,4.6c-3.61,3.07-5.88,6.83-6.8,11.28Z"
        />
      </g>

      <g>
        <path
          className="cls-1"
          d="M293.52,228.35c-.15,12.19-2.75,23.83-7.77,34.55-4.25,9.12-10.27,17.66-17.89,25.41-13.41,13.66-29.1,22.23-39.87,27.03-3.77,1.67-7.84,2.55-11.97,2.55s-8.19-.87-11.97-2.55c-10.77-4.8-26.43-13.36-39.87-27.03-7.62-7.74-13.64-16.29-17.89-25.41-5.02-10.72-7.62-22.36-7.74-34.55-.1-6.62,1.17-13.21,3.75-19.33,2.47-5.82,6.12-11.07,10.72-15.41,4.52-4.25,9.87-7.52,15.71-9.62,6.1-2.17,12.54-3.02,19.16-2.55,7.96.58,15.57,3.2,22.14,7.55,3.07,2.03,3.28,6.47.51,8.9l-10.98,9.6c-1.25,1.1-1.7,2.85-1.12,4.4l14.09,39.17-24.71-29.28c-1-1.17-2.6-1.7-4.1-1.3l-13.66,3.62c-1.77.47-3,2.07-3,3.9v14.61c0,1.77,1.15,3.32,2.84,3.84l40.85,12.59h-32.07c-1.8,0-3.38,1.19-3.87,2.92l-3.9,13.69c-.62,2.15.6,4.37,2.75,4.97l14.11,4.12c1.32.37,2.75.08,3.77-.82l21.56-18.84-2.17,27.85c-.1,1.17.82,2.17,2,2.17h6.2c1.17,0,2.1-1,2-2.17l-2.17-27.85,21.56,18.84c1.02.9,2.45,1.2,3.77.82l14.14-4.12c2.12-.6,3.35-2.82,2.75-4.97l-3.92-13.69c-.49-1.73-2.07-2.92-3.87-2.92h-32.07l40.85-12.59c1.69-.52,2.84-2.08,2.84-3.84v-14.61c0-1.83-1.23-3.43-3-3.9l-13.66-3.62c-1.5-.4-3.1.12-4.1,1.3l-24.68,29.28,14.09-39.17c.55-1.55.1-3.3-1.15-4.4l-10.98-9.6c-2.77-2.42-2.55-6.86.52-8.9,6.57-4.36,14.19-6.98,22.13-7.55,6.64-.47,13.09.37,19.16,2.55,11.94,4.27,21.51,13.36,26.43,25.03,2.57,6.12,3.87,12.71,3.77,19.33Z"
        />
      </g>
    </svg>
  );
};

export default LogoPrimaryShape;
